import React from 'react';
import PropTypes from 'prop-types';

const AddTaxFile = props => {
  return <div>AddTaxFile</div>;
};

AddTaxFile.propTypes = {};

export default AddTaxFile;
